// extracted by mini-css-extract-plugin
module.exports = {"signature":"Team-module--signature--Tgvdf","boxedImage":"Team-module--boxed-image--3VOA4"};